import { MarketoServices as MarketoLogo } from '@clearkit/icons';

import marketoTheme from './theme';

export default {
  logo: MarketoLogo,
  theme: marketoTheme,
};
